import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import Home from '../views/Home.vue'
import Register from '../views/Register.vue'
import ForgetPassword from '../views/ForgetPassword.vue'
import ResetPassword from '../views/ResetPassword.vue'
import UserActivation from '../views/UserActivation.vue'
import Profile from '../views/Profile.vue'
import SelectSemester from '../views/SelectSemester.vue'
import Terms from '../views/Terms.vue'
import Form_1 from '../views/Form_1.vue'
import Form_2 from '../views/Form_2.vue'
import Form_3 from '../views/Form_3.vue'
import Form_4 from '../views/Form_4.vue'
import Form_5 from '../views/Form_5.vue'
import Form_Pay from '../views/Form_Pay.vue'
import Form_Check from '../views/Form_Check.vue'
import Recommenders from '../views/Recommenders.vue'
import QualificationForm from '../views/QualificationForm.vue'
import ApplicationFormPrintPage from '../views/ApplicationFormPrintPage.vue'

// import Form from '../views/Form.vue'
// import Form_2 from '../views/Form_2.vue'
// import Form_3 from '../views/Form_3.vue'
// import Form_4 from '../views/Form_4.vue'
// import Form_5 from '../views/Form_5.vue'
// import Form_6 from '../views/Form_6.vue'
// import QualificationForm from '../views/QualificationForm.vue'
// import QualificationForm_2 from '../views/QualificationForm_2.vue'
// import QualificationForm_3 from '../views/QualificationForm_3.vue'
// import Disclaimer from '../views/Disclaimer.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresGuest: true }
  },
  {
    path: '/Register',
    name: 'Register',
    component: Register,
    meta: { requiresGuest: true }
  },
  {
    path: '/ForgetPassword',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: { requiresGuest: true }
  },
  {
    path: '/ResetPassword/:resetCode',
    name: 'ResetPassword',
    component: ResetPassword,
    props: true,
    meta: { requiresGuest: true }
  },
  {
    path: '/Active/:activeCode',
    name: 'UserActivation',
    component: UserActivation,
    props: true,
    meta: { requiresGuest: true }
  },
  {
    path: '/Profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/SelectSemester',
    name: 'SelectSemester',
    component: SelectSemester,
    meta: { requiresAuth: true }
  },
  {
    path: '/Terms',
    name: 'Terms',
    component: Terms,
    meta: { requiresAuth: true }
  },
  {
    path: '/Apply/1',
    name: 'Form_1',
    component: Form_1,
    meta: { requiresAuth: true }
  },
  {
    path: '/Apply/2',
    name: 'Form_2',
    component: Form_2,
    meta: { requiresAuth: true }
  },
  {
    path: '/Apply/3',
    name: 'Form_3',
    component: Form_3,
    meta: { requiresAuth: true }
  },
  {
    path: '/Apply/4',
    name: 'Form_4',
    component: Form_4,
    meta: { requiresAuth: true }
  },
  {
    path: '/Apply/5',
    name: 'Form_5',
    component: Form_5,
    meta: { requiresAuth: true }
  },
  {
    path: '/Apply/Pay',
    name: 'Form_Pay',
    component: Form_Pay,
    meta: { requiresAuth: true }
  },
  {
    path: '/Apply/Check',
    name: 'Form_Check',
    component: Form_Check,
    meta: { requiresAuth: true }
  },
  {
    path: '/Recommenders/:linkCode',
    name: 'Recommenders',
    component: Recommenders,
    meta: { }
  },
  {
    path: '/QualificationForm',
    name: 'QualificationForm',
    component: QualificationForm,
    meta: { requiresAuth: true }
  },
  {
    path: '/Print',
    name: 'ApplicationFormPrintPage',
    component: ApplicationFormPrintPage,
    meta: { requiresAuth: true }
  },

  // {
  //   path: '/Form_2',
  //   name: 'Form_2',
  //   component: Form_2,
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: '/Form_3',
  //   name: 'Form_3',
  //   component: Form_3,
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: '/Form_4',
  //   name: 'Form_4',
  //   component: Form_4,
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: '/Form_5',
  //   name: 'Form_5',
  //   component: Form_5,
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: '/Form_6',
  //   name: 'Form_6',
  //   component: Form_6,
  //   meta: { requiresAuth: true }
  // },


  // {
  //   path: '/QualificationForm_2',
  //   name: 'QualificationForm_2',
  //   component: QualificationForm_2,
  //   meta: { requiresAuth: true }
  // },

  // {
  //   path: '/QualificationForm_3',
  //   name: 'QualificationForm_3',
  //   component: QualificationForm_3,
  //   meta: { requiresAuth: true }
  // },

  // {
  //   path: '/Disclaimer',
  //   name: 'Disclaimer',
  //   component: Disclaimer,
  //   meta: { requiresAuth: true }
  // },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters.isLoggedIn;

  // 判斷是否是需要登入的頁面
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // 未登入則導入到登入頁
      next({
        path: '/',
      });
    } else {
      next();
    }
  }
  // 判斷是否為不登入才可瀏覽的頁面
  else if (to.matched.some(record => record.meta.requiresGuest)) {
    if (isAuthenticated) {
      // 導入到帳號資訊頁
      next('/Profile');
    } else {
      next();
    }
  }
  else {
    next();
  }
});

// 捕獲並忽略由 next(false) 產生的導航中止錯誤
// 這些錯誤是預期的行為（例如使用者在離開前確認對話框中選擇取消）
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 忽略導航相關的錯誤：取消、中止、重複
    if (
      err.name === 'NavigationDuplicated' ||
      err.message.includes('Navigation cancelled') ||
      err.message.includes('Navigation aborted')
    ) {
      return Promise.resolve();
    }
    return Promise.reject(err);
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    // 忽略導航相關的錯誤：取消、中止、重複
    if (
      err.name === 'NavigationDuplicated' ||
      err.message.includes('Navigation cancelled') ||
      err.message.includes('Navigation aborted')
    ) {
      return Promise.resolve();
    }
    return Promise.reject(err);
  });
};

export default router
